// Default audio configuration values and small helpers

export const MASTER_VOLUME_DEFAULT = 0.6;
export const MUSIC_VOLUME_DEFAULT = 0.5;
export const SFX_VOLUME_DEFAULT = 0.7;

export const RATE_LIMIT_MS = {
  SHOOT: 80,
  UI_CLICK: 50,
} as const;

export const CROSSFADE_MS_DEFAULT = 600;

export function clamp01(v: number): number {
  if (Number.isNaN(v)) return 0;
  return Math.max(0, Math.min(1, v));
}